import './sass/main.scss';
import './js/menu.js';
import './js/modal.js';
